<ng-content select="[wbSessionListLogo]"></ng-content>

<span class="heading">{{ $title() }}</span>

<span class="description">
  You have reached your limit of {{ $limit() }} active sessions on WorkBuddy. Please end another session before logging in.
</span>

<w-content-list [headerTitle]="$listTitle()" [headerActions]="[$endAllCommand]">
  @for (vm of $vm(); track vm.session.id) {
    <w-list-item w-content-list-item [icon]="'fa-regular fa-calendar'" [header]="$sessionHeader(vm.session)" [description]="$sessionDescription(vm.session)" [command]="vm.endCommand" />
  }
</w-content-list>

<button class="try-again" (click)="tryAgain.emit()">Try again</button>
